const timeDepositConstants = {
  TIMELIMIT_CHANGED: 'TIMELIMIT_CHANGED',
  AMOUNT_CHANGED: 'AMOUNT_CHANGED',
  DEPOSIT_TYPE_CHANGED: 'DEPOSIT_TYPE_CHANGED',
  STEP_CHANGED: 'STEP_CHANGED',
  SIMULATION_REQUEST: 'SIMULATION_REQUEST',
  SIMULATION_SUCCESS: 'SIMULATION_SUCCESS',
  SIMULATION_FAILURE: 'SIMULATION_FAILURE',
  SIMULATION_SELECTED: 'SIMULATION_SELECTED',
  LIST_REQUEST: 'LIST_REQUEST',
  LIST_SUCCESS: 'LIST_SUCCESS',
  LIST_FAILURE: 'LIST_FAILURE',
  TIME_DEPOSIT_REQUEST: 'TIME_DEPOSIT_REQUEST',
  TIME_DEPOSIT_SUCCESS: 'TIME_DEPOSIT_SUCCESS',
  TIME_DEPOSIT_FAILURE: 'TIME_DEPOSIT_FAILURE',
  TERMS_CHANGED: 'TERMS_CHANGED',
  ACCOUNT_OUT_CHANGED: 'ACCOUNT_OUT_CHANGED',
  ACCOUNT_IN_CHANGED: 'ACCOUNT_IN_CHANGED',
  SIGN_IN_REQUEST: 'SIGN_IN_REQUEST',
  SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
  SIGN_IN_FAILURE: 'SIGN_IN_FAILURE',
  SIMULATION_CLEANED: 'SIMULATION_CLEANED',
  RESULT_CLEANED: 'RESULT_CLEANED',
  LIQUIDATE_REQUEST: 'LIQUIDATE_REQUEST',
  LIQUIDATE_SUCCESS: 'LIQUIDATE_SUCCESS',
  LIQUIDATE_FAILURE: 'LIQUIDATE_FAILURE',
  LIQUIDATE_ACCOUNT_CHANGED: 'LIQUIDATE_ACCOUNT_CHANGED',
  LIQUIDATE_CLEANED: 'LIQUIDATE_CLEANED',
  EXPIRATION_DATE_CHANGED: 'EXPIRATION_DATE_CHANGED',
  HOLIDAYS_REQUEST: 'HOLIDAYS_REQUEST',
  HOLIDAYS_SUCCESS: 'HOLIDAYS_SUCCESS',
  HOLIDAYS_FAILURE: 'HOLIDAYS_FAILURE',
  DEF_EXP_DATE_CHANGED: 'DEF_EXP_DATE_CHANGED',
  RATING_SELECTED: 'RATING_SELECTED',
  ASSESMENT_COMMENT_CHANGED: 'ASSESMENT_COMMENT_CHANGED',
  LOAD_CONFIG_DAP_SUCCESS:'LOAD_CONFIG_DAP_SUCCESS',
  LOAD_CONFIG_DAP_FAILURE: 'LOAD_CONFIG_DAP_FAILURE'
};

export default timeDepositConstants;
